import { FC } from 'react';
import Image from 'next/image';
import { Chip } from '@mofid-securities/uikit';
import { RowCard } from '@/components/RowCard';
import { TransactionCardAmount } from './components';
import { toFormattedDate } from '@/utils/date';
import { getImageSrc } from './TransactionCard.utils';
import { ITransactionCardProps } from './TransactionCard.types';

export const TransactionCard: FC<ITransactionCardProps> = ({
  title,
  amount,
  date,
  onClick,
  type,
  chipTitle,
  chipVariant,
}) => {
  const imageSrc = getImageSrc(type);

  const formattedDate =
    date && toFormattedDate(date, 'dddd، D MMMM YYYY - HH:mm');

  return (
    <RowCard
      className="!px-0"
      classNames={{
        root: '!px-2 !py-1',
        imageContainer: '!ml-2',
      }}
      description={formattedDate}
      descriptionFontSize="xs"
      imageComponent={
        <Image alt="Transaction" height={32} src={imageSrc} width={32} />
      }
      radius="2xl"
      secondDescription={<Chip variant={chipVariant}>{chipTitle}</Chip>}
      secondDescriptionFontSize="xs"
      secondTitle={<TransactionCardAmount amount={amount} />}
      secondTitleFontSize="sm"
      title={title}
      titleFontSize="sm"
      onClick={onClick}
    />
  );
};
